import { thunk, Thunk } from 'easy-peasy';
import { InviteCollaboratorsController } from '../../../controllers/InvitateCollaboratorsController';
import HttpClientWithRetry from '../../../http/client/HttpClientWithRetry';
import { HttpStoreModel } from '../../../http/models/httpModel';
import { BusinessResponse } from '../../administration/positionManagement/BusinessType';
import { InviteCollaborators } from './InviteCollaboratorsTypes';

export type InviteCollaboratorsStoreModel = {
  inviteCollaborators: InviteCollaboratorsModel;
};

export interface InviteCollaboratorsModel {
  sendInvitationToCollaborators: Thunk<
    InviteCollaboratorsModel,
    {
      collaborators: InviteCollaborators;
    },
    void,
    HttpStoreModel,
    Promise<BusinessResponse>
  >;
  getInvitationLink: Thunk<
    InviteCollaboratorsModel,
    {
      collaborators: InviteCollaborators;
    },
    void,
    HttpStoreModel,
    Promise<{ invitationLink: string }>
  >;
  getCollaboratorsInvite: Thunk<
    InviteCollaboratorsModel,
    {
      bookingId: string;
    },
    void,
    HttpStoreModel,
    Promise<InviteCollaborators>
  >;
  getInviteeEmail: Thunk<
    InviteCollaboratorsModel,
    {
      bookingId: string;
    },
    void,
    HttpStoreModel,
    Promise<InviteCollaborators['inviteeEmails']>
  >;
  inviteCollaboratorsToInterview: Thunk<
    InviteCollaboratorsModel,
    {
      collaborators: InviteCollaborators;
    },
    void,
    HttpStoreModel,
    Promise<BusinessResponse>
  >;
}

export const inviteCollaboratorsStoreModel: InviteCollaboratorsModel = {
  sendInvitationToCollaborators: thunk(async (_actions, payload, { getStoreState }) => {
    const controller = new InviteCollaboratorsController(getStoreState().http.client as HttpClientWithRetry);
    const response = await controller.sendInvitation(payload.collaborators);
    return response?.data as BusinessResponse;
  }),
  getInvitationLink: thunk(async (_actions, payload, { getStoreState }) => {
    const controller = new InviteCollaboratorsController(getStoreState().http.client as HttpClientWithRetry);
    const response = await controller.getInvitationLink(payload.collaborators);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return response?.data;
  }),
  getCollaboratorsInvite: thunk(async (_actions, payload, { getStoreState }) => {
    const controller = new InviteCollaboratorsController(getStoreState().http.client as HttpClientWithRetry);
    const response = await controller.getCollaboratorsInvite(payload.bookingId);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
    return response?.data?.videoInterviewInvite as InviteCollaborators;
  }),
  getInviteeEmail: thunk(async (_actions, payload, { getStoreState }) => {
    const controller = new InviteCollaboratorsController(getStoreState().http.client as HttpClientWithRetry);
    const response = await controller.getInviteeEmail(payload.bookingId);
    return (response?.data as { inviteeEmails: InviteCollaborators['inviteeEmails'] })?.inviteeEmails;
  }),
  inviteCollaboratorsToInterview: thunk(async (_actions, payload, { getStoreState }) => {
    const controller = new InviteCollaboratorsController(getStoreState().http.client as HttpClientWithRetry);
    const response = await controller.inviteCollaborators(payload.collaborators);
    return response?.data as BusinessResponse;
  }),
};
